var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{attrs:{"label":_vm.label}},[_c('KdzGoodsConfigList',{attrs:{"value":_vm.mValue},on:{"edit":_vm.edit}}),(_vm.show)?_c('KdzGoodsConfigChoose',{attrs:{"show":_vm.show,"value":_vm.mValue},on:{"update:show":function($event){_vm.show=$event},"submit":_vm.replace}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }